import { RouteComponentProps } from '@reach/router';

interface AccessPointsDetailsProps extends RouteComponentProps {}

export const AccessPointsDetails: React.FC<AccessPointsDetailsProps> = () => {
  return <div>AccessPointsDetails</div>;
};
